import PropTypes from "prop-types";
import "./CardAdresses.scss";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash, faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import {useEffect, useState} from "react";
import Toast from "../Toast/toast";
import Swal from "sweetalert2";

function CardAdressses({
                           adresseId,
                           adresse,
                           ville,
                           codePostal,
                           pays,
                           complementAdresse,
                           nomPersonne,
                           prenomPersonne,
                           numTel,
                           setAdresses, adresses
                       }) {
    const navigate = useNavigate();
    const [btnDelete, setBtnDelete] = useState(false);
    const [toast, setToast] = useState({icon: '', text: ''});

    const handleClickEditAdresse = () => {
        navigate(`/Profil/adresses/${adresseId}`, {
            state: {
                adresseId, adresse, ville, codePostal, pays, complementAdresse, nomPersonne, prenomPersonne, numTel
            },
        });
    };

    useEffect(() => {
        if (!btnDelete) {
            return;
        }
        Swal.fire({
            title: "Êtes-vous sûr?",
            text: "Veuillez confirmer votre choix.",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer",
        }).then((result) => {
            if (result.isConfirmed) {
                const handleDeleteAdress = async () => {
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}adresses/delete`, {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${Cookies.get("auth_token")}`,
                            },
                            body: JSON.stringify({idAdresse: adresseId})
                        });
                        if (response.ok) {
                            const adressesData = await response.json();
                            setAdresses(adressesData);
                            Swal.fire({
                                text: "Adresse supprimée avec succès.",
                                toast: true,
                                icon: "success",
                                showConfirmButton: false,
                                background: "#fff",
                                timer: 2000,
                                position: "top-end",
                                padding: "0.5em",
                                color: "#000",
                            });
                        }
                    } catch (error) {
                        console.log(error);
                        setToast({
                            icon: "error",
                            text: "Une erreur s'est produite lors de la suppression de l'adresse."
                        });
                    }
                };
                handleDeleteAdress();
            }
            setBtnDelete(false);
        });
    }, [btnDelete, adresseId]);


    return (
        <>
            {toast.text && <Toast icon={toast.icon} text={toast.text}></Toast>}
            <div className="card-adresse-main">
                <div className="container-left-adresses">
                    <h4 className="adresse-name">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        {prenomPersonne} {nomPersonne}
                    </h4>
                    <p className="adresse-details">
                        {adresse}
                        {complementAdresse && <><br/>{complementAdresse}</>}
                        <br/>
                        {codePostal} {ville}
                        <br/>
                        {pays}
                        <br/>
                        {numTel}
                    </p>
                </div>
                <div className="container-right-adresses">
                    <button className="btn-edit" onClick={handleClickEditAdresse} title="Modifier l'adresse">
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button className="btn-delete" onClick={() => setBtnDelete(true)} title="Supprimer l'adresse">
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            </div>
        </>
    );
}

CardAdressses.propTypes = {
    adresse: PropTypes.string.isRequired,
    ville: PropTypes.string.isRequired,
    codePostal: PropTypes.string.isRequired,
    pays: PropTypes.string.isRequired,
    complementAdresse: PropTypes.string,
    nomPersonne: PropTypes.string,
    prenomPersonne: PropTypes.string,
    numTel: PropTypes.string.isRequired,
};
export default CardAdressses;
